export default __webpack_public_path__ + "images/pictograms/lorry.svg?80d5b9f60a5fe56ab5a984c9953692dbeb56f08928bd18900d87098979e904e6";